import { FC } from 'react';
import Checkbox from 'components/forms/Checkbox';
import { language } from 'utils/i18n';

const riskLink = `https://www.tradeup.com/agreement/173?lang=${language}`;
const optLink = `https://www.tradeup.com/agreement/182?lang=${language}`;

export const optCheckboxLabel = language.startsWith('zh') ? (
    <>
        * 本人已阅读并理解
        <a href={riskLink} target="_blank" data-inapp-blank title="《标准化期权的特点和风险》">
            《标准化期权的特点和风险》
        </a>
        ，接受
        <a href={optLink} target="_blank" data-inapp-blank title="《期权协议》">
            《期权协议》
        </a>
        的所有条款和条件，包括其中的<strong>仲裁条款</strong>
        。本人确认所提供的一切信息均准确、真实、无误导性陈述，并将及时通知贵方任何变更。
    </>
) : (
    <>
        * I have read and understand the{' '}
        <a href={riskLink} target="_blank" data-inapp-blank title="Characteristics and Risks of Standardized Options">
            Characteristics and Risks of Standardized Options
        </a>
        . I accept all terms and conditions in the{' '}
        <a href={optLink} target="_blank" data-inapp-blank title="Options Agreement">
            Options Agreement
        </a>
        , including its <strong>arbitration clause</strong>. I affirm that all information provided is accurate, true,
        not misleading, and I will promptly notify you of any changes.
    </>
);

const OptAgreeCheckbox: FC<{ disabled?: boolean }> = ({ disabled }) => {
    return (
        <Checkbox
            disabled={disabled}
            name="temporary_read_opt_perm"
            $defaultValue={true}
            checker={value => !!value || __('请您阅读并同意上述协议')}
            label={optCheckboxLabel}
        />
    );
};

export default OptAgreeCheckbox;
